export const CLASS_NAMES = {
  wrapper: "relative flex flex-col border-transparent",
  editorWrapper: "min-h-20",
  focusedInput:
    "px-2 outline-none border-solid border-transparent border-turquoise-300 border",
  focusedPlaceHolder: "",
};

export const DISABLED_COMMANDS = ["underlined"];
